module.exports = __webpack_public_path__ + "media/images/component/sink-294d6beb1760d2b9264ad42e8d017afd.svg";